(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5342],{

/***/ 36958:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/producten",
      function () {
        return __webpack_require__(36141);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 36141:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ producten; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/modules/common/components/head/index.tsx
var head = __webpack_require__(63269);
// EXTERNAL MODULE: ./src/modules/layout/templates/index.tsx + 13 modules
var templates = __webpack_require__(77092);
// EXTERNAL MODULE: ./src/modules/products/components/infinite-products/index.tsx
var infinite_products = __webpack_require__(73687);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/medusa-react/dist/medusa-react.esm.js + 1 modules
var medusa_react_esm = __webpack_require__(12863);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./src/lib/config.ts
var config = __webpack_require__(17590);
;// CONCATENATED MODULE: ./src/lib/util/get-product-filters.ts



var getProductFilters = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(collectionId) {
        var filter, products, options, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    filter = {
                        limit: 1000
                    };
                    if (collectionId) filter["collection_id"] = [
                        collectionId
                    ];
                    return [
                        4,
                        config/* medusaClient.products.list */.pZ.products.list(filter).then(function(param) {
                            var products = param.products;
                            return products;
                        })
                    ];
                case 1:
                    products = _state.sent();
                    options = {};
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        _loop = function() {
                            var product = _step.value;
                            product.options.forEach(function(option) {
                                if (typeof options[option.title] === "undefined") options[option.title] = {};
                                option.values.forEach(function(value) {
                                    if (!Object.keys(options[option.title]).includes(value.value)) options[option.title][value.value] = [
                                        product.id
                                    ];
                                    else if (!options[option.title][value.value].includes(product.id)) options[option.title][value.value].push(product.id);
                                });
                            });
                        };
                        for(_iterator = products[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return [
                        2,
                        options
                    ];
            }
        });
    });
    return function getProductFilters(collectionId) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 4 modules
var transition = __webpack_require__(84539);
// EXTERNAL MODULE: ./node_modules/react-icons/bs/index.esm.js
var index_esm = __webpack_require__(63750);
;// CONCATENATED MODULE: ./src/modules/store/components/refinement-list/index.tsx












var RefinementList = function(param) {
    var refinementList = param.refinementList, setRefinementList = param.setRefinementList, _showCollection = param.showCollection, showCollection = _showCollection === void 0 ? true : _showCollection, collectionId = param.collectionId;
    var ref, ref1;
    var ref2 = (0,react.useState)(""), filterDropdown = ref2[0], setFilterDropdown = ref2[1];
    var ref3 = (0,medusa_react_esm/* useCollections */.bXJ)(), collections = ref3.collections, isLoading = ref3.isLoading;
    var filterData = (0,es.useQuery)([
        "get_product_filters",
        collectionId
    ], function() {
        return getProductFilters(collectionId);
    });
    var handleCollectionChange = function(e, id) {
        var checked = e.target.checked;
        var collectionIds = refinementList.collection_id || [];
        var exists = collectionIds.includes(id);
        if (checked && !exists) {
            setRefinementList((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, refinementList), {
                collection_id: (0,_to_consumable_array/* default */.Z)(collectionIds).concat([
                    id
                ])
            }));
            return;
        }
        if (!checked && exists) {
            setRefinementList((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, refinementList), {
                collection_id: collectionIds.filter(function(c) {
                    return c !== id;
                })
            }));
            return;
        }
        return;
    };
    var handleFilterChange = function(e, opt_id, values) {
        var checked = e.target.checked;
        var filters = refinementList.filters || {};
        var exists = Object.keys(filters).includes(opt_id);
        if (checked && !exists) {
            setRefinementList((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, refinementList), {
                filters: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters), (0,_define_property/* default */.Z)({}, opt_id, values))
            }));
            return;
        }
        if (!checked && exists) {
            var newFilters = (0,_object_spread/* default */.Z)({}, filters);
            delete newFilters[opt_id];
            setRefinementList((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, refinementList), {
                filters: newFilters
            }));
            return;
        }
        return;
    };
    var ref4, _filters, _filters1, _filters2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)("small:sticky small:top-[100px] py-4 flex gap-y-2 text-darkTone px-0 flex-col w-full flex-1 "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative flex small:flex-col px-3 pb-2 w-auto text-2xl font-semibold font-display items-start subpixel-antialiased",
                children: "Filters"
            }),
            showCollection && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)("relative flex gap-x-3 z-20 flex-col small:gap-y-3 px-3 w-full border-b-2 border-lightTone pb-2"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        onClick: function() {
                            return setFilterDropdown(filterDropdown === "collecties" ? "" : "collecties");
                        },
                        className: "flex flex-row justify-between font-semibold text-lg font-display w-full pr-4 h-[30px] md:h-[38px] text-darkTone border-0 focus:outline-none items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "select-none",
                                children: [
                                    "Collecties",
                                    ((ref4 = refinementList === null || refinementList === void 0 ? void 0 : (ref = refinementList.collection_id) === null || ref === void 0 ? void 0 : ref.length) !== null && ref4 !== void 0 ? ref4 : 0) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "pl-2 text-xs font-normal text-neutral-500",
                                        children: [
                                            "(",
                                            (ref1 = refinementList.collection_id) === null || ref1 === void 0 ? void 0 : ref1.length,
                                            " ",
                                            "geselecteerd)"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                className: (0,clsx_m/* default */.Z)("w-6 h-6 stroke-current stroke-1 transition-all duration-300", {
                                    "-scale-100": filterDropdown === "collecties"
                                }),
                                viewBox: "0 0 384 512",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M191.1 352c-1.1 0-3.969-.7344-5.531-2.219L34.47 205.8c-3.187-3.047-3.312-8.125-.25-11.31c3.094-3.188 8.156-3.281 11.31-.25l146.5 138.7l146.5-138.7c3.219-3.031 8.281-2.938 11.31 .25c3.062 3.188 2.937 8.266-.25 11.31l-151.1 144C195.1 351.3 193.1 352 191.1 352z"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                        show: filterDropdown === "collecties",
                        as: "ul",
                        unmount: false,
                        className: (0,clsx_m/* default */.Z)("relative z-10 py-2 transition-all origin-top duration-500 overflow-hidden w-full", "text-base-regular flex flex-col items-left px-4 gap-x-4 small:gap-y-2", "border-l border-lightTone"),
                        enterFrom: "transform scale-95 opacity-0 max-h-0",
                        enterTo: "transform scale-100 opacity-100 max-h-[1000px]",
                        leaveFrom: "transform scale-100 opacity-100 max-h-[1000px]",
                        leaveTo: "transform scale-95 opacity-0 max-h-0",
                        children: collections === null || collections === void 0 ? void 0 : collections.map(function(c) {
                            var ref, ref1, ref2;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                    className: (0,clsx_m/* default */.Z)("flex items-center gap-x-2 cursor-pointer", {
                                        "text-accent": (ref = refinementList.collection_id) === null || ref === void 0 ? void 0 : ref.includes(c.id)
                                    }),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "checkbox",
                                            defaultChecked: (ref1 = refinementList.collection_id) === null || ref1 === void 0 ? void 0 : ref1.includes(c.id),
                                            onChange: function(e) {
                                                return handleCollectionChange(e, c.id);
                                            },
                                            className: (0,clsx_m/* default */.Z)("accent-amber-200 hidden")
                                        }),
                                        c.title,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BsCheck */.oFd, {
                                            size: 24,
                                            className: (0,clsx_m/* default */.Z)("absolute right-3", {
                                                " hidden": !((ref2 = refinementList.collection_id) === null || ref2 === void 0 ? void 0 : ref2.includes(c.id))
                                            })
                                        })
                                    ]
                                })
                            }, "collectie-".concat(c.id));
                        })
                    })
                ]
            }, "collecties-filter"),
            typeof filterData.data !== "undefined" && Object.keys(filterData.data).map(function(key) {
                var ref;
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)("relative flex gap-x-3 z-20 flex-col small:gap-y-3 px-3 w-full border-b-2 border-lightTone pb-2"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            onClick: function() {
                                return setFilterDropdown(filterDropdown === key ? "" : key);
                            },
                            className: "flex flex-row justify-between font-semibold text-lg font-display w-full pr-4 h-[30px] md:h-[38px] text-darkTone border-0 focus:outline-none items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "select-none",
                                    children: key
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    className: (0,clsx_m/* default */.Z)("w-6 h-6 stroke-current stroke-1 transition-all duration-300", {
                                        "-scale-100": filterDropdown === key
                                    }),
                                    viewBox: "0 0 384 512",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M191.1 352c-1.1 0-3.969-.7344-5.531-2.219L34.47 205.8c-3.187-3.047-3.312-8.125-.25-11.31c3.094-3.188 8.156-3.281 11.31-.25l146.5 138.7l146.5-138.7c3.219-3.031 8.281-2.938 11.31 .25c3.062 3.188 2.937 8.266-.25 11.31l-151.1 144C195.1 351.3 193.1 352 191.1 352z"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                            show: filterDropdown === key,
                            as: "ul",
                            unmount: false,
                            className: (0,clsx_m/* default */.Z)("relative z-10 py-2 transition-all origin-top duration-500 overflow-hidden w-full", "text-base-regular flex flex-col items-left px-4 gap-x-4 small:gap-y-2", "border-l border-lightTone"),
                            enterFrom: "transform scale-95 opacity-0 max-h-0",
                            enterTo: "transform scale-100 opacity-100 max-h-[1000px]",
                            leaveFrom: "transform scale-100 opacity-100 max-h-[1000px]",
                            leaveTo: "transform scale-95 opacity-0 max-h-0",
                            children: (ref = Object.keys(filterData.data[key])) === null || ref === void 0 ? void 0 : ref.map(function(label) {
                                var ref, ref1, ref2;
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                        className: (0,clsx_m/* default */.Z)("flex items-center gap-x-2 cursor-pointer", {
                                            "text-accent": (ref = Object.keys((_filters = refinementList.filters) !== null && _filters !== void 0 ? _filters : {})) === null || ref === void 0 ? void 0 : ref.includes("".concat(key, "-").concat(label))
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: "checkbox",
                                                defaultChecked: (ref1 = Object.keys((_filters1 = refinementList.filters) !== null && _filters1 !== void 0 ? _filters1 : {})) === null || ref1 === void 0 ? void 0 : ref1.includes("".concat(key, "-").concat(label)),
                                                onChange: function(e) {
                                                    return handleFilterChange(e, "".concat(key, "-").concat(label), filterData.data[key][label]);
                                                },
                                                className: "accent-amber-200 hidden"
                                            }),
                                            label,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BsCheck */.oFd, {
                                                size: 24,
                                                className: (0,clsx_m/* default */.Z)("absolute right-3", {
                                                    " hidden": !((ref2 = Object.keys((_filters2 = refinementList.filters) !== null && _filters2 !== void 0 ? _filters2 : {})) === null || ref2 === void 0 ? void 0 : ref2.includes("".concat(key, "-").concat(label)))
                                                })
                                            })
                                        ]
                                    })
                                }, "".concat(key, "-").concat(label));
                            })
                        })
                    ]
                }, key);
            })
        ]
    });
};
/* harmony default export */ var refinement_list = (RefinementList);

// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
;// CONCATENATED MODULE: ./src/pages/producten.tsx








var AkoestischePanelen = function() {
    var ref = (0,react.useState)({}), params = ref[0], setParams = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(head/* default */.Z, {
                title: "Producten",
                description: "Explore all of our products."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grain-background",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative z-10 grid grid-cols-6 px-4 py-7 lg:px-12 lg:py-20",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,clsx_m/* default */.Z)("col-span-2 ml-16"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "text-lg md:text-xl lg:text-3xl 2xl:text-5xl font-display font-base subpixel-antialiased mb-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "producten-title",
                                        defaultMessage: "Producten"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-4 ml-16 text-darkTone",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-base mb-6 px-8 mx-auto font-mono subpixel-antialiased"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative block col-span-1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(refinement_list, {
                                    refinementList: params,
                                    setRefinementList: setParams
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-5 px-8 transition flex flex-col small:items-start py-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "content-container ",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(infinite_products["default"], {
                                        params: params
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute inset-0 z-0 pointer-events-none",
                        style: {
                            background: "linear-gradient(\n" + "    to right,\n" + "    transparent 0%,\n" + "    transparent 33.33%,\n" + "    #f6f6f6 33.33%,\n" + "    #f6f6f6 100%\n" + "  )"
                        },
                        children: "\xa0"
                    })
                ]
            })
        ]
    });
};
AkoestischePanelen.getLayout = function(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(templates/* default */.Z, {
        children: page
    });
};
/* harmony default export */ var producten = (AkoestischePanelen);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9128,3662,3415,1228,5445,5937,4617,6158,6556,2013,3815,6659,2931,7092,3687,9774,2888,179], function() { return __webpack_exec__(36958); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);